<template>
	<div :id="id" class="schedule_detail">
		<strong class="txt_day">{{dateText}}</strong>
		<div class="wrap_schedule">
			<schedule v-for="schedule in schedules" :schedule="schedule" :date="date"></schedule>
		</div>
	</div>
</template>

<script>
	import { parseISO, format } from 'date-fns';
	import ko from 'date-fns/locale/ko';

	import Schedule from './Schedule.vue';

	export default {
		components: { Schedule },

		props: ['schedules', 'date'],
		computed: {
			id() {
				return `date-${this.date}`;
			},
			dateText() {
				return format(parseISO(this.date), 'dd. eeee', { locale: ko });
			},
		},
	}
</script>
